/*
 * @Author: zhangzhe 437050740@qq.com
 * @Date: 2023-12-05 16:01:22
 * @LastEditors: zhangzhe 437050740@qq.com
 * @LastEditTime: 2023-12-06 16:38:38
 * @FilePath: \market\src\network\request.js
 */
import axios from "axios";
import nprogress from "nprogress";
import "nprogress/nprogress.css";

const base = require("@/network/config");
let Base64 = require('js-base64').Base64;

// 创建axios实例
const requests = axios.create({
  baseURL: base,
  timeout: 15000, // 缩短超时时间到15秒
});

// 全局重试配置
const MAX_RETRIES = 2;
const INITIAL_DELAY = 1000; // 初始重试延迟1秒

// 请求拦截器
requests.interceptors.request.use((config) => {
  nprogress.start();
  
  // 为GET请求添加时间戳参数，防止缓存
  if (config.method?.toLowerCase() === 'get') {
    config.params = config.params || {};
    config.params['_t'] = Date.now();
  }
  
  return config;
});

// 响应拦截器 - 带重试逻辑
const responseInterceptor = (res) => {
  nprogress.done();
  return res.data;
};

const errorInterceptor = async (error) => {
  nprogress.done();
  
  const { config, response, code } = error;
  
  // 如果没有配置或超过最大重试次数，直接返回错误
  if (!config || !config.retryCount) {
    config.retryCount = 0;
  }
  
  // 网络错误、超时或5xx错误时重试
  if (code === 'ERR_NETWORK' || 
      code === 'ECONNABORTED' || 
      (response && response.status >= 500)) {
    
    if (config.retryCount < MAX_RETRIES) {
      config.retryCount++;
      
      // 指数退避延迟
      const delay = INITIAL_DELAY * Math.pow(2, config.retryCount - 1);
      
      await new Promise(resolve => setTimeout(resolve, delay));
      
      // 重新发起请求
      return requests(config);
    }
  }
  
  // 返回统一错误格式
  return {
    code: -1,
    msg: error.message || '请求失败',
    data: null
  };
};

requests.interceptors.response.use(responseInterceptor, errorInterceptor);

export default requests;